<ng-template #tooltipTemplate>
  <div data-test="oC8UR0N6" (click)="$event.stopPropagation()" *mdAutorun>
    <ng-template [ngTemplateOutlet]="timeTooltipContent_"></ng-template>
    <br data-test="a6gQ_Qtf" />
    <a
      data-test="a9MyLwn4"
      class="dont-show-time-tooltip-again-btn"
      (click)="handleDontShowTimeTooltipAgain()"
    >
      Don't show this again.
    </a>
  </div>
</ng-template>

<div
  data-test="xfMjp8Ft"
  *mdAutorun
  (keydown)="toggleTooltip(true)"
  (mdOutsideClick)="toggleTooltip(false)"
>
  <input
    data-test="GAPYJvJv"
    [mdDisableInput]="inputDisabled_"
    [attr.id]="inputId_"
    [mdHoverPopover]="tooltipTemplate"
    mdHoverPopoverTrigger="manual"
    [mdHoverPopoverVisible]="isTooltipOpen"
    mdHoverPopoverPlacement="right"
    mdHoverPopoverClass="time-mask-tooltip"
    [ngModel]="modelValue"
    [ngClass]="inputClasses_"
    (blur)="inputBlurHandle()"
    (keydown.enter)="enterHandle()"
    #inputWithoutControl
    mdTimeMask
    class="input text-center"
    type="text"
    placeholder="00:00"
    (changeValue)="writeValue($event)"
    (input)="changeInputValue($event)"
    [size]="5"
  />
</div>
